module.exports = function(bootstrap) {
	bootstrap.run(["Service", "services", function (Service, services) {
		new Service({
			name: 'spendingAccountTypes',
			group: "rbsmbl",
			url: "/rbsmbl/x-services/spendingAccount/getAccountTypes",
			fetch: function(payload) {
				this.payload = payload || {"payload":{}};
				return this.post(this.payload);
			}
		});
	}]);
};